
const Requirements = () => {
  const requirements = [
    {
      title: 'Employment Verification',
      description: 'Proof of stable employment and income to demonstrate repayment ability',
      icon: 'ri-briefcase-line',
      details: ['Recent pay stubs', 'Employment letter', 'Tax returns (if self-employed)']
    },
    {
      title: 'Reasonable Collateral',
      description: 'Assets or guarantees to secure the loan based on loan type and amount',
      icon: 'ri-shield-check-line',
      details: ['Property documents', 'Vehicle registration', 'Investment statements']
    },
    {
      title: 'Financial Literacy Commitment',
      description: 'Participation in our financial education workshops and ongoing support',
      icon: 'ri-book-open-line',
      details: ['Workshop attendance', 'Financial planning session', 'Ongoing mentorship']
    },
    {
      title: 'Membership Requirements',
      description: 'Active membership in Landmark Cooperative with savings account',
      icon: 'ri-user-heart-line',
      details: ['Cooperative membership', 'Active savings account', 'Community participation']
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Loan Requirements
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our requirements are designed to ensure responsible lending while remaining accessible to our community
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {requirements.map((requirement, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 text-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${requirement.icon} text-xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{requirement.title}</h3>
                  <p className="text-gray-600 mb-4">{requirement.description}</p>
                  <ul className="space-y-2">
                    {requirement.details.map((detail, detailIndex) => (
                      <li key={detailIndex} className="flex items-center text-sm text-gray-700">
                        <i className="ri-check-line text-teal-600 mr-2"></i>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-blue-50 rounded-xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Special Considerations for Newcomers
            </h3>
            <p className="text-gray-600 mb-6 max-w-3xl mx-auto">
              We understand the unique challenges faced by immigrants and newcomers. Our settlement loans have 
              modified requirements and additional support services to help you establish yourself in Canada.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <i className="ri-global-line text-3xl text-blue-600 mb-2"></i>
                <h4 className="font-semibold text-gray-900">Flexible Documentation</h4>
                <p className="text-sm text-gray-600">Alternative documentation accepted for newcomers</p>
              </div>
              <div className="text-center">
                <i className="ri-heart-line text-3xl text-blue-600 mb-2"></i>
                <h4 className="font-semibold text-gray-900">Settlement Support</h4>
                <p className="text-sm text-gray-600">Comprehensive guidance for Canadian integration</p>
              </div>
              <div className="text-center">
                <i className="ri-team-line text-3xl text-blue-600 mb-2"></i>
                <h4 className="font-semibold text-gray-900">Community Network</h4>
                <p className="text-sm text-gray-600">Connect with other community members and mentors</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Requirements;
